<li class="pc" *ngIf="hasLoginSys"
[class.member-loading]="loginIng"
[class.member-show]="memberInfo"
[class.dropdown]="memberInfo">
  <a href="javascript:void(0)" (click)="openCultureCenterLogin()" role="button" title="{{'openLoginWindow' | translate}}[{{'openNewWindow' | translate}}]"
  *ngIf="!memberInfo">
    <i class="fa fa-user" aria-hidden="true"></i>
    <!-- <span *ngIf="memberInfo"> {{ 'hello' | translate: ({value: memberInfo.name}) }}</span> -->
    <span *ngIf="!memberInfo"> {{'login' | translate}}</span>
  </a>
  <ng-container *ngIf="memberInfo">
    <a href="javascript:void(0)" class="dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false" id="memberDropdown">
      <i class="fa fa-user" aria-hidden="true"></i>
      {{ 'hello' | translate: ({value: memberInfo.name}) }}
    </a>
    <div class="dropdown-menu" aria-labelledby="memberDropdown">
      <a class="dropdown-item" role="button" [routerLink]="[toHomePath, 'memberCollection']" routerLinkActive="active">我的收藏</a>
      <a class="dropdown-item" role="button" tabindex="0" (click)="openPrefere()">內容偏好</a>
    </div>
    <app-member-preference-modal></app-member-preference-modal>
  </ng-container>
</li>

<li class="pc" *ngIf="memberInfo"><a href="javascript:void(0)" class="member-logout-btn" (click)="logout()"
    title="{{'logout' | translate}}"><i class="fa fa-sign-out fa-fw "></i></a></li>

